require('./bootstrap');
import { createI18n } from 'vue-i18n'
import messages from './translations'

// import Alpine from 'alpinejs';


// window.Alpine = Alpine;

// Alpine.start();

let locale = document.documentElement.lang
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  fallbackLocale: 'en',
  messages,
})

import { createApp } from 'vue'
import { store } from './store'
import LightboxGallery from '@/components/LightboxGallery.vue'
import ContactForm from '@/components/ContactForm.vue'
import YouTubeVideo from '@/components/YouTubeVideo.vue'

const app = createApp({})

app.use(store)
app.component('lightbox-gallery', LightboxGallery)
app.component('contact-form', ContactForm)
app.component('contact-form', ContactForm)
app.component('youtube-video', YouTubeVideo)
app.use(i18n)

app.mount('#app')




import 'slick-carousel'


require('./clicks');
require('./slicks');


// $('.home-section-excursions__excursions').slick({
//   arrows : false,
//   dots : true,
//   // normal options...
//   infinite : true,
//   slidesToShow: 3,
//   slidesToScroll: 3,


//   // the magic
//   responsive: [{

//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         infinite: true
//       }

//     }, {

//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true
//       }

//     },
//   ]
// })

// $('.private-excursions-index__excursions').slick({
//   arrows : false,
//   dots : true,
//   // normal options...
//   infinite : true,
//   slidesToShow: 4,


//   // the magic
//   responsive: [{

//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         infinite: true
//       }

//     }, {

//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         dots: true
//       }

//     },
//   ]
// })

// $('.card-excursion__carousel').slick({
//   autoplay: true,
//   autoplaySpeed : 3000,
//   speed : 1000, //transition speed
//   fade : true,
//   arrows : false,
//   // normal options...
//   infinite : true,
//   slidesToShow: 1,
// })


